import { render, staticRenderFns } from "./CsSolicitudesInternasPresupuesto.vue?vue&type=template&id=97d37b72"
import script from "./CsSolicitudesInternasPresupuesto.vue?vue&type=script&lang=js"
export * from "./CsSolicitudesInternasPresupuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports